import OptimizelyPage from './OptimizelyPage'

export default OptimizelyPage
// eslint-disable-next-line import/export
export * from './OptimizelyPage'
